import React from "react";
import dayjs from "dayjs";
import { Calendar, Select, DatePicker, Button } from "antd";
import * as json from "Common/Json";
import "./Styles/Calendar.scss";
import utils from "utils";
import Icons from "Common/Icons";
export default class extends React.Component {
  constructor(props) {
    super(props);
    const defaultDay = this.props.defaultValue
      ? dayjs(this.props.defaultValue)
      : utils.TimezoneOffsetConversion();
    this.state = {
      currentMonth: defaultDay,
      selectedDate: defaultDay,
    };
  }


  handleDateSelect(value) {
    this.setState({
      selectedDate: value,
      currentMonth: dayjs(value)
    });
    typeof this.props.onSelect == "function" && this.props.onSelect(value);
  }

  handleDisableDate(current) {
    if (typeof this.props.disabledDate == "function") {
      return this.props.disabledDate(current);
    } else {
      return current < utils.TimezoneOffsetConversion().startOf("day");
    }
  }

  handleMonthChange(type, action, onChange) {
    if (action == "add") {
      this.setState(
        {
          currentMonth: dayjs(this.state.currentMonth.add(1, type)),
        },
        () => {
          onChange(this.state.currentMonth);
          
        }
      );
    } else if (action == "subtract") {
      this.setState(
        {
          currentMonth: dayjs(this.state.currentMonth.subtract(1, type)),
        },
        () => {
          onChange(this.state.currentMonth);
        }
      );
    }
  }

  handleShowToday() {
    this.setState(
      {
        selectedDate: utils.TimezoneOffsetConversion(),
        currentMonth: utils.TimezoneOffsetConversion(),
      },
      () => {
        this.changeDate(utils.TimezoneOffsetConversion());
      }
    );
  }

  isCurrentDate() {
    let c_date = utils.TimezoneOffsetConversion().date(),
      c_month = utils.TimezoneOffsetConversion().month(),
      c_year = utils.TimezoneOffsetConversion().year();
    let s_date = dayjs(this.state.selectedDate).date(),
      s_month = dayjs(this.state.selectedDate).month(),
      s_year = dayjs(this.state.selectedDate).year();
    if (c_date == s_date && c_month == s_month && c_year == s_year) {
      return true;
    }
    return false;
  }
  render() {
    return (
      <div className="calendar-component">
        <div>
          <Calendar
            fullscreen={false}
            defaultValue={this.props.defaultValue || null}
            disabledDate={this.handleDisableDate.bind(this)}
            headerRender={({ value, type, onChange, onTypeChange }) => {
              this.changeDate = onChange;
              
              return (
                <div className="calendar-header">
                  {this.props.iconHide ? (
                    <div className="header-previous-icon">
                      <img
                        src={Icons.previous}
                        onClick={(e) => {
                          this.handleMonthChange(
                            "months",
                            "subtract",
                            onChange
                          );
                        }}
                      /> 
                    </div>
                  ) : null}
                  <DatePicker
                  getPopupContainer={()=>{return null;}}
                    value={this.state.currentMonth}
                    format={json.formats["DATE_8"]}
                    onChange={(value) => {
                        this.setState({
                        currentMonth: dayjs(value),
                      });
                      onChange(value);
                    }}
                    className="calendar-month-picker"
                    suffixIcon={null}
                    allowClear={false}
                    picker="month"
                    // disabled={this.props.iconHide ? true : false}
                  />
                  {this.props.iconHide ? (
                    <div className="header-next-icon">
                      <img
                        src={Icons.next}
                        onClick={(e) => {
                          this.handleMonthChange("months", "add", onChange);
                          
                        }}
                      />
                    </div>
                  ) : null}
                </div>
              );
            }}
            // onPanelChange={this.onPanelChange.bind(this)}
            onSelect={this.handleDateSelect.bind(this)}
          />
          {this.props.showToday ? <div
            className={`calendar-footer${this.isCurrentDate() ? " hide" : ""}`}
          >
            <Button onClick={this.handleShowToday.bind(this)}>Today</Button>
          </div> : null}
        </div>
      </div>
    );
  }
}
